import React from "react";
import { DynamicModalContent } from "../../../contenful/types";



// OBS CHANGE CLASS NAME
const ModalContent = ({ title, text, image, backgroundImage }: Partial<DynamicModalContent>): JSX.Element => {
  const img = image ? image.fields.file.url : "";
  const bgImg = backgroundImage ? backgroundImage.fields.file.url : "";

  return (
    <section style={{backgroundImage: `url(${bgImg})`}} className="modal-dynamic-content-section">
      {img && <img className="modal-dynamic-content-img" src={img} alt="logo" />}
      <div className="modal--dynamic-content-text">
        {title && <h3>{title}</h3>}
        {text && <p>{text}</p>}
      </div>
    </section>
  );
};

export default ModalContent;
